import Team from '@/models/Team/team';

export default class Fixture {
  constructor({
    status = null,
    awayTeam = new Team(),
    homeTeam = new Team(),
  } = {}) {
    this.status = status;
    this.awayTeam = awayTeam ? Team.createFromObject(awayTeam) : null;
    this.homeTeam = homeTeam ? Team.createFromObject(homeTeam) : null;
  }

  static createFromObject(data) {
    return new Fixture(data);
  }
}
